import { subMonths, format, startOfMonth } from "date-fns";

export function getFilterReferenceDate(): { month: string; year: string } {
  const currentDate = new Date();
  const referenceDate = subMonths(currentDate, 1);

  // backend expects months 1-12
  const referenceMonth = (referenceDate.getMonth() + 1).toString();
  const referenceYear = referenceDate.getFullYear().toString();

  return { month: referenceMonth, year: referenceYear };
}

export function getFilterStartEndDates(): {
  periodStart: string;
  periodEnd: string;
} {
  const today = new Date();
  const BACKEND_ISO_FORMAT = "yyyy'-'MM'-'dd";

  const firstDayOfRange = format(startOfMonth(today), BACKEND_ISO_FORMAT);
  const lastDayOfRange = format(today, BACKEND_ISO_FORMAT);

  return { periodStart: firstDayOfRange, periodEnd: lastDayOfRange };
}
